<template>
  <div class="public-screen">
    <div class="header-main">

      <div class="header-main-image">
        <img src="https://landerpop.s3.us-east-1.amazonaws.com/landerpop.png" />
      </div>
      
    </div>

    <!-- begin login bar -->
    <login-bar />
    <!-- /end login bar -->

    <div class="beta-container">
      <div>
        <h1>Signup for Beta and Product Information</h1>
        <p>
          If you are here, you know something about what's going on and your
          interest is appreciated. We are working hard at finishing the
          Landerpop initial product up for early access and testing. If you are
          interested in using the application fill out the form and we will
          contact you as soon as possible.
        </p>
        <p>
          Thanks,<br />
          The Landerpop Team
        </p>
      </div>

      <!-- begin beta signup form -->
      <beta-signup-form label="About You" />
      <!-- /end beta signup form -->
    </div>
  </div>
</template>

<script>
import LoginBar from "@/components/navigation/LoginBar.vue";
import BetaSignupForm from "@/components/forms/BetaSignupForm.vue";

export default {
  name: "HomeView",
  components: { LoginBar, BetaSignupForm },
};
</script>
